import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { SCRAPED_BRAND_CACHE_KEY } from "./keys";

import { ScrapedBrandFilters } from "@/types/scraped-brand";
import { ScrapedBrandRepository } from "@/repositories/scraped-brand";

export const useGetScrapedBrands = (filters: ScrapedBrandFilters) => {
  const scrapedBrandRepository = useRef(new ScrapedBrandRepository());

  return useQuery({
    queryKey: SCRAPED_BRAND_CACHE_KEY.LIST(filters),
    queryFn: async () => {
      return await scrapedBrandRepository.current.findAll(filters);
    },
    placeholderData: keepPreviousData,
  });
};
